"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContextProvider = exports.createStore = void 0;
var react_1 = __importStar(require("react"));
function createStore(reducer, defaultValue) {
    var Store = (0, react_1.createContext)({ state: defaultValue });
    function StoreProvider(_a) {
        var children = _a.children;
        var _b = (0, react_1.useReducer)(reducer, defaultValue), state = _b[0], dispatch = _b[1];
        return react_1.default.createElement(Store.Provider, { value: { state: state, dispatch: dispatch } }, children);
    }
    ;
    return { Store: Store, StoreProvider: StoreProvider };
}
exports.createStore = createStore;
function createContextProvider(reducer, defaultValue) {
    var _a = createStore(reducer, defaultValue), Store = _a.Store, StoreProvider = _a.StoreProvider;
    return [Store, StoreProvider];
}
exports.createContextProvider = createContextProvider;
//# sourceMappingURL=store-utils.js.map